import { Component, ComponentFactoryResolver, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { SettingsService } from '../shared/settings/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { ViewModeDirective } from './view-mode.directive';
import { BottomNavigationComponent, SidebarNavigationComponent, TopbarNavigationComponent } from './navigation';
import { LdwRouterService } from '../route/ldw-router.service';
import { ToolbarPosition } from '../shared/enums/toolbar-position';
import { RBCheck } from '@ldw/roesberg';
import { Observable } from 'rxjs';
import { AppUrls } from '../route/app-urls';
import { AppConfig } from '../appconfig';

@Component({
  selector: 'ldw-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.css'],
  standalone: false
})
export class MainNavigationComponent implements OnInit {
  private routerService = inject(LdwRouterService);
  private settingsService = inject(SettingsService);
  private resolver = inject(ComponentFactoryResolver);
  private config = inject(AppConfig);

  isAuthenticated!: Observable<boolean>;
  loaded = false;
  @ViewChild(ViewModeDirective, { static: true })
  viewModeHost!: ViewModeDirective;

  constructor() {
    const translate = inject(TranslateService);
    const settingsService = this.settingsService;

    settingsService.settings.themes.setSelectedTheme(1);
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
  }

  ngOnInit(): void {
    this.settingsService.getSettings().subscribe((res) => {
      if (res) {
        this.loaded = true;
        this.settingsLoaded();
      }
    });
    if (this.config.hasError()) {
      this.routerService.errorStop('CONFIGERROR');
    }
  }

  settingsLoaded() {
    // subscribe to mode changes
    this.settingsService.settings.viewMode.modeChange.subscribe(() => {
      this.updateView();
    });
    this.updateView();
    //this.webDokuService.initializeWebDokus();
  }

  updateView() {
    const tbPos = this.settingsService.settings.viewMode.toolbarPosition;
    if (tbPos === ToolbarPosition.Top) {
      this.createChildComponent(TopbarNavigationComponent);
    } else if (tbPos === ToolbarPosition.Left) {
      this.createChildComponent(SidebarNavigationComponent);
    } else if (tbPos === ToolbarPosition.Bottom) {
      this.createChildComponent(BottomNavigationComponent);
    }
  }

  createChildComponent(viewComponent: any) {
    const child = this.resolver.resolveComponentFactory(viewComponent);

    const viewContainerRef = this.viewModeHost.viewContainerRef;
    viewContainerRef.clear();

    //const cmpRef =
    viewContainerRef.createComponent(child);
  }

  @HostListener('window:appscan', ['$event'])
  onAppScan(e: any) {
    if (e == null || e.detail == undefined) {
      return;
    }
    const scantext = e.detail;
    if (!RBCheck.isNullOrEmpty(scantext)) {
      this.routerService.navigateToSearch(scantext, true);
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(e: any) {
    if (!AppUrls.domainMatchMvc(e.origin)) {
      //console.log('domain mismatch on iframe message');
      return;
    }

    if (e.data != undefined && e.data.type != undefined) {
      if (e.data.type === 'fullscreen' && e.data.value != undefined) {
        this.settingsService.settings.viewMode.isFullScreen = e.data.value == true;
      }
    }
    return undefined;
  }

  /*
  @HostListener('window:message', ['$event'])
  onMessage(e: any) {

    if (!AppUrls.domainMatch(e.origin)) {
      console.log("domain mismatch on iframe message");
      return;
    }

    if (e.data != undefined && e.data.type != undefined  && e.data.id != undefined)
    {
      if (e.data.type === "Saved") {
        this.documentService.changedDocument(e.data.id).subscribe( () => {});
      }
    }
    return undefined;
  }
  */
}
